import {useLocation} from "react-router-dom";
import {useEffect, useLayoutEffect, useReducer, useState} from "react";
import {irr} from "financial";
import {
    percentageToFloat,
    parse,
    parseNumber,
} from "../methods/contentFormatHelpers";
import { validateInput } from "../methods/contentFormatHelpers";
import getValuation from "../methods/api/getValuation";
import {CalcData} from "../interfaces/calcData";

const years: number = 21;
const useValutationData = () => {
    const [isLoading, setIsLoading] = useState(true);
    const location = useLocation();
    const calcData: CalcData = {
        amortyzacja: [], analiza_rynku: "", analiza_wrazliwosci_lic_niewyl_minus_10: 0, analiza_wrazliwosci_lic_niewyl_plus_10: 0, analiza_wrazliwosci_lic_wyl_minus_10: 0, analiza_wrazliwosci_lic_wyl_plus_10: 0, analiza_wrazliwosci_spp_minus_10: 0, analiza_wrazliwosci_spp_plus_10: 0, cel_wyceny: "", cena_jednostkowa: [], cena_jednostkowa_zl: 0, charakterystyka_przedmiotu_wyceny: "", data_spotkania: undefined, dodatkowy_sprzet: 0, efektywne_opodatkowanie: 0, forma_stosowanej_ochrony: "", horyzont_planowania: 0, inne_koszty: [], irr_val: 0, koszty_calkowite: [], koszty_stale: 0, koszty_stale_produkcji: [], koszty_zmienne: 0, koszty_zmienne_produkcji: [], liniowa_zmiana_cen: 0, miejscowosc: "", naklady_inwestycyjne: 0, naklady_inwestycyjne_obliczeniowy: [], npv: [], numer_prawa_wylacznego: "", numer_wewnetrzny_wi: "", numer_zgloszenia: "", obliczenia_amortyzacji: [], opis_przedmiotu_wyceny: "", opracowanie: "", osoba_opracowujaca: "", osoba_zatwierdzajaca: "", penetracja_rynku: [], penetracja_rynku_n_0: 0, penetracja_rynku_n_10: 0, podatek_dochodowy: [], podmioty_uprawnione: "", podstawy_wyceny: "", portfel_technologiczny: "", przeplywy_pieniezne_netto: [], przychody_ze_sprzedazy: [], przychody_ze_sprzedazy_zl: 0, rentownosc_branzy: 0, srodki_trwale_dodatkowy_sprzet: [], stawka_amortyzacji_st: 0, stopa_dyskontowa: 0, stopa_dyskontowa_obliczeniowy: [], suma_przeplywow_netto_okres_analizy_zl_10: 0, suma_przeplywow_netto_okres_analizy_zl_15: 0, suma_przeplywow_netto_okres_analizy_zl_20: 0, suma_przeplywow_za_okres_analizy: 0, tworcy: "", tytul: "", udzial_ip: "", wartosc_licencja_niewylaczna: 0, wartosc_licencja_wylaczna: 0, wartosc_rynkowa_thumb_rule: 0, wartosc_szacowanej_sprzedazy: [], wartosc_w_przedsprzedazy: 0, wielkosc_rynku_docelowego: [], wielkosc_rynku_docelowego_szt: 0, wrazliwosc_na_zmiany: 0, wskaznik_rentownosci_dla_branzy: 0, wycena_wnip: "", wynik_finansowy_brutto: [], wynik_finansowy_netto: [], wynik_finansowy_netto_przypisany_ip: [], wzrost_rynku_docelowego: 0, wzrost_wielkosci_sprzedazy: 0, zaktualizowana_wartosc_przeplywow_pienieznych_netto: [], zestawienie_przeplywow_npv_10: 0, zestawienie_przeplywow_npv_15: 0, zestawienie_przeplywow_npv_20: 0, zysk_jednostkowy_brutto: 0, zysk_jednostkowy_ip: 0, zysk_jednostkowy_netto: 0,
        wielkosc_szacowanej_sprzedazy_szt:0,

    }
    const [valuationData, setValuationData] = useReducer(reducer, calcData);

    // @ts-ignore
    function reducer(valuationData : CalcData, action: {type:string, payload:CalcData}) : CalcData {
        let s = action.payload;

        let wielkosc_rynku_docelowego :number[];
        let penetracja_rynku:number[];
        let naklady_inwestycyjne_obliczeniowy:number[];
        let srodki_trwale_dodatkowy_sprzet:number[];
        let obliczenia_amortyzacji:number[];
        let wartosc_szacowanej_sprzedazy:number[];
        let cena_jednostkowa:number[];
        let przychody_ze_sprzedazy:number[];
        let amortyzacja:number[];
        let koszty_zmienne_produkcji:number[];
        let koszty_stale_produkcji:number[];
        let inne_koszty:number[];
        let koszty_calkowite:number[];
        let wynik_finansowy_brutto:number[];
        let podatek_dochodowy:number[];
        let wynik_finansowy_netto:number[];
        let naklady_inwestycyjne:number[];
        let wynik_finansowy_netto_przypisany_ip:number[];
        let przeplywy_pieniezne_netto:number[];
        let stopa_dyskontowa_obliczeniowy:number[];
        let zaktualizowana_wartosc_przeplywow_pienieznych_netto:number[];
        let npv:number[];

        let wielkosc_szacowanej_sprzedazy_szt:number;
        let przychody_ze_sprzedazy_zl:number;
        let zysk_jednostkowy_brutto:number;
        let zysk_jednostkowy_netto:number;
        let wskaznik_rentownosci_dla_branzy:number;
        let suma_przeplywow_netto_okres_analizy_zl_10:number;
        let suma_przeplywow_za_okres_analizy:number;
        let zestawienie_przeplywow_npv_10:number;
        let irr_val:number;
        let wartosc_rynkowa_thumb_rule:number;
        let wartosc_w_przedsprzedazy:number;
        let wartosc_licencja_wylaczna:number;
        let wartosc_licencja_niewylaczna:number;
        let zysk_jednostkowy_ip:number;

        switch (action.type) {
            case "set":
                s = action.payload;

                wielkosc_rynku_docelowego = [...Array(years)].map((elem, index) => {
                    elem =
                        parseFloat(String(s.wielkosc_rynku_docelowego_szt || 0)) *
                        Math.pow(percentageToFloat(s.wzrost_rynku_docelowego || 0), index);
                    return elem;
                });
                penetracja_rynku = parse(s.penetracja_rynku) || [];
                naklady_inwestycyjne_obliczeniowy =
                    parse(s.naklady_inwestycyjne_obliczeniowy) || [];
                srodki_trwale_dodatkowy_sprzet =
                    parse(s.srodki_trwale_dodatkowy_sprzet) || [];
                obliczenia_amortyzacji = (() => {
                    let a, b, c;
                    a = srodki_trwale_dodatkowy_sprzet[0] || 0;
                    c = percentageToFloat(s.stawka_amortyzacji_st) || 0;
                    let arr = [a - a * c];

                    for (let i = 1; i < years; i++) {
                        a = arr[i - 1] || 0;
                        b = srodki_trwale_dodatkowy_sprzet[0] || 0;
                        c = percentageToFloat(s.stawka_amortyzacji_st) || 0;
                        arr[i] = a - b * c;
                    }
                    return arr;
                })();
                wartosc_szacowanej_sprzedazy = [...Array(years)].map((elem, index) => {
                    let a = wielkosc_rynku_docelowego[index] || 0;
                    let b = percentageToFloat(penetracja_rynku[index]) || 0;
                    return a * b;
                });
                cena_jednostkowa = (() => {
                    let a, b;
                    a = s.cena_jednostkowa_zl || 0;
                    b = percentageToFloat(s.liniowa_zmiana_cen) || 0;

                    let arr = [parseFloat(a.toString())];

                    for (let i = 1; i < years; i++) {
                        a = arr[i - 1] || 0;
                        arr[i] = a * b;
                    }
                    return arr;
                })();
                przychody_ze_sprzedazy = [...Array(years)].map((elem, index) => {
                    let a = wartosc_szacowanej_sprzedazy[index];
                    let b = cena_jednostkowa[index];
                    a = a ? a : 0;
                    b = b ? b : 0;
                    return a * b;
                });
                amortyzacja = [...Array(years)].map((elem, index) => {
                    return obliczenia_amortyzacji[index] > 0
                        ? obliczenia_amortyzacji[index]
                        : 0;
                });
                koszty_zmienne_produkcji = (() => {
                    let a, b;
                    b = percentageToFloat(s.koszty_zmienne) || 0;
                    let arr = [];
                    for (let i = 0; i < years; i++) {
                        a = przychody_ze_sprzedazy[i];
                        arr[i] = a * b;
                    }
                    return arr;
                })();
                koszty_stale_produkcji = [...Array(years)].map((elem, index) => {
                    return (
                        (percentageToFloat(s.koszty_stale) || 0) *
                        (przychody_ze_sprzedazy[index] || 0)
                    );
                });
                inne_koszty = parse(s.inne_koszty) || [];
                koszty_calkowite = [...Array(years)].map((elem, index) => {
                    return parseNumber(
                        (amortyzacja[index] || 0) +
                        (koszty_zmienne_produkcji[index] || 0) +
                        (koszty_stale_produkcji[index] || 0) +
                        (inne_koszty[index] || 0)
                    );
                });
                wynik_finansowy_brutto = [...Array(years)].map((elem, index) => {
                    return (
                        (przychody_ze_sprzedazy[index] || 0) -
                        (koszty_calkowite[index] || 0)
                    );
                });
                podatek_dochodowy = [...Array(years)].map((elem, index) => {
                    return (
                        (wynik_finansowy_brutto[index] || 0) *
                        (percentageToFloat(s.efektywne_opodatkowanie) || 0)
                    );
                });
                wynik_finansowy_netto = [...Array(years)].map((elem, index) => {
                    return (
                        (wynik_finansowy_brutto[index] || 0) -
                        (podatek_dochodowy[index] || 0)
                    );
                });
                wynik_finansowy_netto_przypisany_ip = [...Array(years)].map(
                    (elem, index) => {
                        return (
                            (wynik_finansowy_netto[index] || 0) *
                            (percentageToFloat(s.udzial_ip) || 0)
                        );
                    }
                );
                przeplywy_pieniezne_netto = [...Array(years)].map((elem, index) => {
                    return (
                        (wynik_finansowy_netto_przypisany_ip[index] || 0) -
                        (naklady_inwestycyjne_obliczeniowy[index] || 0) +
                        (amortyzacja[index] || 0)
                    );
                });
                stopa_dyskontowa_obliczeniowy = [...Array(years)].map((elem, index) => {
                    return (
                        1 /
                        Math.pow(
                            1 + (percentageToFloat(s.stopa_dyskontowa) || 0),
                            index + 1
                        )
                    );
                });
                zaktualizowana_wartosc_przeplywow_pienieznych_netto = [
                    ...Array(years),
                ].map((elem, index) => {
                    return (
                        (przeplywy_pieniezne_netto[index] || 0) *
                        (stopa_dyskontowa_obliczeniowy[index] || 0)
                    );
                });
                npv = (() => {
                    let temp : number;
                    return [...Array(years)].map((elem, index) => {
                        if (index === 0) {
                            temp =
                                zaktualizowana_wartosc_przeplywow_pienieznych_netto[index] || 0;
                        } else {
                            temp +=
                                zaktualizowana_wartosc_przeplywow_pienieznych_netto[index] || 0;
                        }
                        return temp;
                    });
                })();

                wielkosc_szacowanej_sprzedazy_szt =
                    s.wielkosc_rynku_docelowego_szt *
                    percentageToFloat(s.penetracja_rynku_n_0);
                przychody_ze_sprzedazy_zl =
                    wielkosc_szacowanej_sprzedazy_szt * s.cena_jednostkowa_zl;
                wskaznik_rentownosci_dla_branzy =
                    1 -
                    percentageToFloat(s.koszty_zmienne) -
                    percentageToFloat(s.koszty_stale);
                zysk_jednostkowy_brutto =
                    s.cena_jednostkowa_zl * wskaznik_rentownosci_dla_branzy;
                zysk_jednostkowy_netto =
                    zysk_jednostkowy_brutto -
                    zysk_jednostkowy_brutto *
                    percentageToFloat(s.efektywne_opodatkowanie);
                suma_przeplywow_za_okres_analizy = przeplywy_pieniezne_netto.reduce(
                    (acc, curr) => acc + curr,
                    0
                );
                suma_przeplywow_netto_okres_analizy_zl_10 =
                    suma_przeplywow_za_okres_analizy;
                zestawienie_przeplywow_npv_10 = npv[9];
                irr_val = irr(przeplywy_pieniezne_netto);
                wartosc_w_przedsprzedazy = zestawienie_przeplywow_npv_10;
                wartosc_rynkowa_thumb_rule = wartosc_w_przedsprzedazy * 0.25;
                wartosc_licencja_wylaczna = wartosc_rynkowa_thumb_rule * 0.15;
                wartosc_licencja_niewylaczna = wartosc_rynkowa_thumb_rule * 0.1;
                zysk_jednostkowy_ip =
                    zysk_jednostkowy_netto * percentageToFloat(s.udzial_ip);

                return {
                    ...valuationData,
                    ...action.payload,
                    wielkosc_rynku_docelowego,
                    penetracja_rynku,
                    naklady_inwestycyjne_obliczeniowy,
                    srodki_trwale_dodatkowy_sprzet,
                    obliczenia_amortyzacji,
                    wartosc_szacowanej_sprzedazy,
                    cena_jednostkowa,
                    przychody_ze_sprzedazy,
                    amortyzacja,
                    koszty_zmienne_produkcji,
                    koszty_stale_produkcji,
                    inne_koszty,
                    koszty_calkowite,
                    wynik_finansowy_brutto,
                    podatek_dochodowy,
                    wynik_finansowy_netto,
                    wynik_finansowy_netto_przypisany_ip,
                    przeplywy_pieniezne_netto,
                    stopa_dyskontowa_obliczeniowy,
                    zaktualizowana_wartosc_przeplywow_pienieznych_netto,
                    npv,
                    wielkosc_szacowanej_sprzedazy_szt,
                    przychody_ze_sprzedazy_zl,
                    zysk_jednostkowy_brutto,
                    wskaznik_rentownosci_dla_branzy,
                    zysk_jednostkowy_netto,
                    suma_przeplywow_za_okres_analizy,
                    suma_przeplywow_netto_okres_analizy_zl_10,
                    zestawienie_przeplywow_npv_10,
                    irr_val,
                    wartosc_w_przedsprzedazy,
                    wartosc_rynkowa_thumb_rule,
                    wartosc_licencja_wylaczna,
                    wartosc_licencja_niewylaczna,
                    zysk_jednostkowy_ip,
                };

            case "update":
                s = { ...valuationData, ...action.payload };

                wielkosc_rynku_docelowego = [...Array(years)].map((elem, index) => {
                    elem =
                        parseFloat(String(s.wielkosc_rynku_docelowego_szt || 0)) *
                        Math.pow(percentageToFloat(s.wzrost_rynku_docelowego || 0), index);
                    return elem;
                });
                penetracja_rynku = s.penetracja_rynku || [];
                naklady_inwestycyjne_obliczeniowy =
                    s.naklady_inwestycyjne_obliczeniowy || [];
                srodki_trwale_dodatkowy_sprzet = s.srodki_trwale_dodatkowy_sprzet || [];
                obliczenia_amortyzacji = (() => {
                    let a, b, c;
                    a = srodki_trwale_dodatkowy_sprzet[0] || 0;
                    c = percentageToFloat(s.stawka_amortyzacji_st) || 0;
                    let arr = [a - a * c];

                    for (let i = 1; i < years; i++) {
                        a = arr[i - 1] || 0;
                        b = srodki_trwale_dodatkowy_sprzet[0] || 0;
                        c = percentageToFloat(s.stawka_amortyzacji_st) || 0;
                        arr[i] = a - b * c;
                    }
                    return arr;
                })();
                wartosc_szacowanej_sprzedazy = [...Array(years)].map((elem, index) => {
                    let a = wielkosc_rynku_docelowego[index] || 0;
                    let b = percentageToFloat(penetracja_rynku[index]) || 0;
                    return a * b;
                });
                cena_jednostkowa = (() => {
                    let a, b;
                    a = s.cena_jednostkowa_zl || 0;
                    b = percentageToFloat(s.liniowa_zmiana_cen) || 0;

                    let arr = [parseFloat(a.toString())];

                    for (let i = 1; i < years; i++) {
                        a = arr[i - 1] || 0;
                        arr[i] = a * b;
                    }
                    return arr;
                })();
                przychody_ze_sprzedazy = [...Array(years)].map((elem, index) => {
                    let a = wartosc_szacowanej_sprzedazy[index];
                    let b = cena_jednostkowa[index];
                    a = a ? a : 0;
                    b = b ? b : 0;
                    return a * b;
                });
                amortyzacja = [...Array(years)].map((elem, index) => {
                    return obliczenia_amortyzacji[index] > 0
                        ? obliczenia_amortyzacji[index]
                        : 0;
                });
                koszty_zmienne_produkcji = (() => {
                    let a, b;
                    b = percentageToFloat(s.koszty_zmienne) || 0;
                    let arr = [];
                    for (let i = 0; i < years; i++) {
                        a = przychody_ze_sprzedazy[i];
                        arr[i] = a * b;
                    }
                    return arr;
                })();
                koszty_stale_produkcji = [...Array(years)].map((elem, index) => {
                    return (
                        (percentageToFloat(s.koszty_stale) || 0) *
                        (przychody_ze_sprzedazy[index] || 0)
                    );
                });
                inne_koszty = s.inne_koszty || [];
                koszty_calkowite = [...Array(years)].map((elem, index) => {
                    return parseNumber(
                        (amortyzacja[index] || 0) +
                        (koszty_zmienne_produkcji[index] || 0) +
                        (koszty_stale_produkcji[index] || 0) +
                        (inne_koszty[index] || 0)
                    );
                });
                wynik_finansowy_brutto = [...Array(years)].map((elem, index) => {
                    return (
                        (przychody_ze_sprzedazy[index] || 0) -
                        (koszty_calkowite[index] || 0)
                    );
                });
                podatek_dochodowy = [...Array(years)].map((elem, index) => {
                    return (
                        (wynik_finansowy_brutto[index] || 0) *
                        (percentageToFloat(s.efektywne_opodatkowanie) || 0)
                    );
                });
                wynik_finansowy_netto = [...Array(years)].map((elem, index) => {
                    return (
                        (wynik_finansowy_brutto[index] || 0) -
                        (podatek_dochodowy[index] || 0)
                    );
                });
                wynik_finansowy_netto_przypisany_ip = [...Array(years)].map(
                    (elem, index) => {
                        return (
                            (wynik_finansowy_netto[index] || 0) *
                            (percentageToFloat(s.udzial_ip) || 0)
                        );
                    }
                );
                przeplywy_pieniezne_netto = [...Array(years)].map((elem, index) => {
                    return (
                        (wynik_finansowy_netto_przypisany_ip[index] || 0) -
                        (naklady_inwestycyjne_obliczeniowy[index] || 0) +
                        (amortyzacja[index] || 0)
                    );
                });
                stopa_dyskontowa_obliczeniowy = [...Array(years)].map((elem, index) => {
                    return (
                        1 /
                        Math.pow(
                            1 + (percentageToFloat(s.stopa_dyskontowa) || 0),
                            index + 1
                        )
                    );
                });
                zaktualizowana_wartosc_przeplywow_pienieznych_netto = [
                    ...Array(years),
                ].map((elem, index) => {
                    return (
                        (przeplywy_pieniezne_netto[index] || 0) *
                        (stopa_dyskontowa_obliczeniowy[index] || 0)
                    );
                });
                npv = (() => {
                    let temp: number;
                    return [...Array(years)].map((elem, index) => {
                        if (index === 0) {
                            temp =
                                zaktualizowana_wartosc_przeplywow_pienieznych_netto[index] || 0;
                        } else {
                            temp +=
                                zaktualizowana_wartosc_przeplywow_pienieznych_netto[index] || 0;
                        }
                        return temp;
                    });
                })();
                wielkosc_szacowanej_sprzedazy_szt =
                    s.wielkosc_rynku_docelowego_szt *
                    percentageToFloat(s.penetracja_rynku_n_0);
                przychody_ze_sprzedazy_zl =
                    wielkosc_szacowanej_sprzedazy_szt * s.cena_jednostkowa_zl;
                wskaznik_rentownosci_dla_branzy =
                    1 -
                    percentageToFloat(s.koszty_zmienne) -
                    percentageToFloat(s.koszty_stale);
                zysk_jednostkowy_brutto =
                    s.cena_jednostkowa_zl * wskaznik_rentownosci_dla_branzy;
                zysk_jednostkowy_netto =
                    zysk_jednostkowy_brutto -
                    zysk_jednostkowy_brutto *
                    percentageToFloat(s.efektywne_opodatkowanie);
                suma_przeplywow_za_okres_analizy = przeplywy_pieniezne_netto.reduce(
                    (acc, curr) => acc + curr,
                    0
                );
                suma_przeplywow_netto_okres_analizy_zl_10 =
                    suma_przeplywow_za_okres_analizy;
                zestawienie_przeplywow_npv_10 = npv[9];
                irr_val = irr(przeplywy_pieniezne_netto);
                wartosc_w_przedsprzedazy = zestawienie_przeplywow_npv_10;
                wartosc_rynkowa_thumb_rule = wartosc_w_przedsprzedazy * 0.25;
                wartosc_licencja_wylaczna = wartosc_rynkowa_thumb_rule * 0.15;
                wartosc_licencja_niewylaczna = wartosc_rynkowa_thumb_rule * 0.1;
                zysk_jednostkowy_ip =
                    zysk_jednostkowy_netto * percentageToFloat(s.udzial_ip);

                return {
                    ...s,
                    wielkosc_rynku_docelowego,
                    penetracja_rynku,
                    naklady_inwestycyjne_obliczeniowy,
                    srodki_trwale_dodatkowy_sprzet,
                    obliczenia_amortyzacji,
                    wartosc_szacowanej_sprzedazy,
                    cena_jednostkowa,
                    przychody_ze_sprzedazy,
                    amortyzacja,
                    koszty_zmienne_produkcji,
                    koszty_stale_produkcji,
                    inne_koszty,
                    koszty_calkowite,
                    wynik_finansowy_brutto,
                    podatek_dochodowy,
                    wynik_finansowy_netto,
                    wynik_finansowy_netto_przypisany_ip,
                    przeplywy_pieniezne_netto,
                    stopa_dyskontowa_obliczeniowy,
                    zaktualizowana_wartosc_przeplywow_pienieznych_netto,
                    npv,
                    wielkosc_szacowanej_sprzedazy_szt,
                    przychody_ze_sprzedazy_zl,
                    zysk_jednostkowy_brutto,
                    wskaznik_rentownosci_dla_branzy,
                    zysk_jednostkowy_netto,
                    suma_przeplywow_za_okres_analizy,
                    suma_przeplywow_netto_okres_analizy_zl_10,
                    zestawienie_przeplywow_npv_10,
                    irr_val,
                    wartosc_w_przedsprzedazy,
                    wartosc_rynkowa_thumb_rule,
                    wartosc_licencja_wylaczna,
                    wartosc_licencja_niewylaczna,
                    zysk_jednostkowy_ip,
                };

            case "update_naklady_inwestycyjne":
                s = { ...valuationData, ...action.payload };

                naklady_inwestycyjne_obliczeniowy = [...Array(5)].map((elem, index) => {
                    return s.naklady_inwestycyjne;
                });
                return {
                    ...s,
                    naklady_inwestycyjne_obliczeniowy,
                };

            case "update_srodki_trwale":
                s = { ...valuationData, ...action.payload };

                srodki_trwale_dodatkowy_sprzet = [...Array(5)].map((elem, index) => {
                    return s.dodatkowy_sprzet;
                });
                return {
                    ...s,
                    srodki_trwale_dodatkowy_sprzet,
                };

            case "update_penetracja_rynku_n10":
                s = { ...valuationData, ...action.payload };
                const step = ((s.penetracja_rynku_n_10/100)-percentageToFloat(s.penetracja_rynku_n_0))/9
                penetracja_rynku = [...Array(years)].map((elem, index) => {
                    if(index === 0) {
                        return percentageToFloat(s.penetracja_rynku_n_0)*100
                    }
                    return  ((percentageToFloat(s.penetracja_rynku_n_0)+(step*index)))*100
                });
                return {
                    ...s,
                    penetracja_rynku,
                };
        }
    }

    interface AnalysisParams {
        sale: number,
        price: number,
        costs: number,
        investment: number
        discountRate? : number,
    }
    const calculateSensitivityAnalysis = (analysisParams: AnalysisParams) => {
        const wielkosc_rynku_docelowego = [...Array(years)].map((elem, index) => {
            elem =
                parseFloat(String(valuationData.wielkosc_rynku_docelowego_szt || 0)) *
                Math.pow(percentageToFloat(valuationData.wzrost_rynku_docelowego || 0), index);
            return elem;
        });
        const penetracja_rynku = valuationData.penetracja_rynku || [];
        const naklady_inwestycyjne_obliczeniowy =
            valuationData.naklady_inwestycyjne_obliczeniowy || [];
        const srodki_trwale_dodatkowy_sprzet = valuationData.srodki_trwale_dodatkowy_sprzet || [];
        const obliczenia_amortyzacji = (() => {
            let a, b, c;
            a = srodki_trwale_dodatkowy_sprzet[0] || 0;
            c = percentageToFloat(valuationData.stawka_amortyzacji_st) || 0;
            let arr = [a - a * c];

            for (let i = 1; i < years; i++) {
                a = arr[i - 1] || 0;
                b = srodki_trwale_dodatkowy_sprzet[0] || 0;
                c = percentageToFloat(valuationData.stawka_amortyzacji_st) || 0;
                arr[i] = a - b * c;
            }
            return arr;
        })();
        const wartosc_szacowanej_sprzedazy = [...Array(years)].map((elem, index) => {
            let a = wielkosc_rynku_docelowego[index] || 0;
            let b = percentageToFloat(penetracja_rynku[index]) || 0;
            return (a * b)*analysisParams.sale;
        });
        const cena_jednostkowa = (() => {
            let a, b;
            a = valuationData.cena_jednostkowa_zl || 0;
            b = percentageToFloat(valuationData.liniowa_zmiana_cen) || 0;

            let arr = [parseFloat(a.toString())];

            for (let i = 1; i < years; i++) {
                a = arr[i - 1] || 0;
                arr[i] = (a * b)*analysisParams.price;
            }
            return arr;
        })();
        const przychody_ze_sprzedazy = [...Array(years)].map((elem, index) => {
            let a = wartosc_szacowanej_sprzedazy[index];
            let b = cena_jednostkowa[index];
            a = a ? a : 0;
            b = b ? b : 0;
            return a * b;
        });
        const amortyzacja = [...Array(years)].map((elem, index) => {
            return obliczenia_amortyzacji[index] > 0
                ? obliczenia_amortyzacji[index]
                : 0;
        });
        const koszty_zmienne_produkcji = (() => {
            let a, b;
            b = percentageToFloat(valuationData.koszty_zmienne) || 0;
            let arr = [];
            for (let i = 0; i < years; i++) {
                a = przychody_ze_sprzedazy[i];
                arr[i] = a * b;
            }
            return arr;
        })();
        const koszty_stale_produkcji = [...Array(years)].map((elem, index) => {
            return (
                (percentageToFloat(valuationData.koszty_stale) || 0) *
                (przychody_ze_sprzedazy[index] || 0)
            );
        });
        const inne_koszty = valuationData.inne_koszty || [];
        const koszty_calkowite = [...Array(years)].map((elem, index) => {
            return parseNumber(
                ((amortyzacja[index] || 0) +
                (koszty_zmienne_produkcji[index] || 0) +
                (koszty_stale_produkcji[index] || 0) +
                (inne_koszty[index] || 0)) * analysisParams.costs
            );
        });
        const wynik_finansowy_brutto = [...Array(years)].map((elem, index) => {
            return (
                (przychody_ze_sprzedazy[index] || 0) -
                (koszty_calkowite[index] || 0)
            );
        });
        const podatek_dochodowy = [...Array(years)].map((elem, index) => {
            return (
                (wynik_finansowy_brutto[index] || 0) *
                (percentageToFloat(valuationData.efektywne_opodatkowanie) || 0)
            );
        });
        const wynik_finansowy_netto = [...Array(years)].map((elem, index) => {
            return (
                (wynik_finansowy_brutto[index] || 0) -
                (podatek_dochodowy[index] || 0)
            );
        });
        const wynik_finansowy_netto_przypisany_ip = [...Array(years)].map(
            (elem, index) => {
                return (
                    (wynik_finansowy_netto[index] || 0) *
                    (percentageToFloat(valuationData.udzial_ip) || 0)
                );
            }
        );
        const przeplywy_pieniezne_netto = [...Array(years)].map((elem, index) => {
            return (
                (wynik_finansowy_netto_przypisany_ip[index] || 0) -
                ((naklady_inwestycyjne_obliczeniowy[index]*analysisParams.investment )|| 0) +
                (amortyzacja[index] || 0)
            );
        });
        const stopa_dyskontowa_obliczeniowy = [...Array(years)].map((elem, index) => {
            if(analysisParams.discountRate){
                return (
                    1 /
                    Math.pow(
                        1 + (percentageToFloat(analysisParams.discountRate) || 0),
                        index + 1
                    )
                );
            }else {
                return (
                    1 /
                    Math.pow(
                        1 + (percentageToFloat(valuationData.stopa_dyskontowa) || 0),
                        index + 1
                    )
                );
            }
        });
        const zaktualizowana_wartosc_przeplywow_pienieznych_netto = [
            ...Array(years),
        ].map((elem, index) => {
            return (
                (przeplywy_pieniezne_netto[index] || 0) *
                (stopa_dyskontowa_obliczeniowy[index] || 0)
            );
        });
        const npv = (() => {
            let temp : number;
            return [...Array(years)].map((elem, index) => {
                if (index === 0) {
                    temp =
                        zaktualizowana_wartosc_przeplywow_pienieznych_netto[index] || 0;
                } else {
                    temp +=
                        zaktualizowana_wartosc_przeplywow_pienieznych_netto[index] || 0;
                }
                return temp;
            });
        })();

        return {npv:npv, irr:irr(przeplywy_pieniezne_netto)};
    }

    const calculateNPVtoDiscountRate = (stopa: number) => {
        let stopa_dyskontowa_obliczeniowy = [...Array(years)].map((elem, index) => {
            return (
                1 /
                Math.pow(
                    1 + (stopa),
                    index + 1
                )
            );
        });
        // console.log(stopa_dyskontowa_obliczeniowy);
        let zaktualizowana_wartosc_przeplywow_pienieznych_netto = [
            ...Array(years),
        ].map((elem, index) => {
            return (
                (valuationData.przeplywy_pieniezne_netto[index] || 0) *
                (stopa_dyskontowa_obliczeniowy[index] || 0)
            );
        });
        let npv = (() => {
            let temp: number;
            return [...Array(years)].map((elem, index) => {
                if (index === 0) {
                    temp =
                        zaktualizowana_wartosc_przeplywow_pienieznych_netto[index] || 0;
                } else {
                    temp +=
                        zaktualizowana_wartosc_przeplywow_pienieznych_netto[index] || 0;
                }
                return temp;
            });
        })();
        return npv[9]
    }
    useEffect(() => {
        if (location.pathname.includes("/wyceny/wycena")) {
            getValuation(window.location.search).then((response) => {
                setValuationData({
                    type: "set",
                    payload: {
                        ...response,
                    },
                });

                Object.keys(valuationData).forEach((key) => {
                    let data;
                    switch (key) {
                        case "penetracja_rynku":
                            data = parse(response[key]);
                            for (let i = 0; i < years; i++) {
                                if (data && response[i])
                                    { // @ts-ignore
                                        document.getElementById(`${key}-${i}`).innerText =
                                                                                response[i];
                                    }
                                validateInput(document.getElementById(`${key}-${i}`));
                            }
                            break;
                        case "naklady_inwestycyjne_obliczeniowy":
                            data = parse(response[key]);
                            for (let i = 0; i < years; i++) {
                                if (data && response[i])
                                    { // @ts-ignore
                                        document.getElementById(`${key}-${i}`).innerText =
                                                                                response[i];
                                    }
                                validateInput(document.getElementById(`${key}-${i}`));
                            }
                            break;
                        case "srodki_trwale_dodatkowy_sprzet":
                            data = parse(response[key]);
                            for (let i = 0; i < years; i++) {
                                if (data && response[i])
                                    { // @ts-ignore
                                        document.getElementById(`${key}-${i}`).innerText =
                                                                                response[i];
                                    }
                                validateInput(document.getElementById(`${key}-${i}`));
                            }
                            break;
                        case "inne_koszty":
                            data = parse(response[key]);
                            for (let i = 0; i < years; i++) {
                                if (data && response[i])
                                    { // @ts-ignore
                                        document.getElementById(`${key}-${i}`).innerText =
                                                                                response[i];
                                    }
                                validateInput(document.getElementById(`${key}-${i}`));
                            }
                            break;
                        case "id":
                            data = parse(response[key]);
                            // @ts-ignore
                            document.getElementsByClassName("valuation_id")[0].innerText =
                                data ? data : response[key];
                            break;
                        default:
                            if (document.getElementById(key)) {
                                // @ts-ignore
                                document.getElementById(key).innerText = response[key];
                            }
                    }
                });
            });
        }
    }, [location]);

    return{
        valuationData,
        calculateSensitivityAnalysis,
        setValuationData,
        calculateNPVtoDiscountRate,
        isLoading
    }
}

export default useValutationData;